
import { Component, OnInit, Inject, AfterViewInit, EventEmitter, Output, Input } from '@angular/core';
import { identifierModuleUrl } from '@angular/compiler';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { DgHubClientService, SettingsRequest, Settings, RetracementSettingsRequest, RetracementTypes } from 'src/app/Services/dg-hub-client.service';
import { DrawingService } from 'src/app/Services/DrawingService';
import { RetracementSettings, IRetracementSettingsRow, IRetracementSettingsRowsSet, ExtensionTypesWithLabel } from 'src/app/Models/RetracementSettings';
import { CookiesService } from 'src/app/Services/cookieService';
import { LineStyle } from 'src/app/Models/lcharts/src/renderers/draw-line';


@Component({
  selector: 'app-retracement-settings',
  templateUrl: './retracement-settings.component.html',
  styleUrls: ['./retracement-settings.component.css']
})
export class RetracementSettingsDialogComponent implements OnInit, AfterViewInit {

  public retracementSettings:RetracementSettings;
  private _retracementsTypes: RetracementTypes;
  public extensionsWithLables:ExtensionTypesWithLabel = new ExtensionTypesWithLabel();
  public get retracementsType(): RetracementTypes {
    return this._retracementsTypes;
  }

  @Input()
  public set retracementsType(value: RetracementTypes)
  {
  switch(value)
  {
    case RetracementTypes.UPWAVE:
        this.selectedRetracementSettingName = this.drawingService.selectedActiveUpwaveRetracementSettingName;
    break;

    case RetracementTypes.DOWNWAVE:
      this.selectedRetracementSettingName = this.drawingService.selectedActiveDownwaveRetracementSettingName;
    break;
  }

   this._retracementsTypes = value;

  }


  public get retracementList(): IRetracementSettingsRowsSet[]
  {
    let list = this.drawingService.retracementsList.filter(v=>{
      return v.type == this.retracementsType
    })

    return list;
  }


  constructor(
    public dialogRef: MatDialogRef<RetracementSettingsDialogComponent>,
    private fb: FormBuilder,
    public dgCLientService:DgHubClientService,
    public drawingService:DrawingService,
    private cookieService: CookiesService
    ) {

  }
  ngAfterViewInit(): void {
    this.toggle = true;
  }

  public levels:IRetracementSettingsRow[] = [];
  ngOnInit() {

    if(this.drawingService.retracementsList)
    {
      this.selectedSetting = this.drawingService.retracementsList.find(v=>{
        return v.name == this.selectedRetracementSettingName && v.type == this.retracementsType
      });

      if(this.selectedSetting==undefined)
      {

        this.selectedSetting = this.drawingService.retracementsList.find(v=>{
          return v.name == "default" && v.type == this.retracementsType
        });

        this.levels = this.drawingService.retracementsList.find(v=>{
          return v.name == "default" && v.type == this.retracementsType
        }).levels;

      }
      else
      {
        let name = (this.retracementsType==RetracementTypes.UPWAVE)?this.drawingService.selectedActiveUpwaveRetracementSettingName:this.drawingService.selectedActiveDownwaveRetracementSettingName;
        this.levels = this.drawingService.retracementsList.find(v=>{
          return v.name == name && v.type == this.retracementsType
        }).levels;
      }


    }
    else
    {
       this.levels = Object.assign(this.drawingService.retracementSettings.currentLevels,[]);

    }

  }

  public toggle:boolean = false;
  public colorUpdate(event,id) {

    this.levels.find(v=>{
      return v.id == id;
    }).color = event.currentTarget.value;

    //console.log(event, id);
    //console.log(this.levels);
    this.settingsChanged();
  }

  public levelUpdate(event,id) {

    this.levels.find(v=>{
      return v.id == id;
    }).levelValue = event.currentTarget.value;

    //console.log(event, id);
    //console.log(this.levels);
    this.settingsChanged();
  }

  public widthUpdate(event,id) {

    this.levels.find(v=>{
      return v.id == id;
    }).width = event.currentTarget.value;

    //console.log(event, id);
    //console.log(this.levels);
    this.settingsChanged();
  }

  public extendUpdate(event,id) {

    this.levels.find(v=>{
      return v.id == id;
    }).isExtended = event.currentTarget.checked;

    //console.log(event, id);
    //console.log(this.levels);
    this.settingsChanged();
  }

  public styleUpdate(event,id) {

    this.levels.find(v=>{
      return v.id == id;
    }).style =  event.currentTarget.value;

    //console.log(event, id);
    //console.log(this.levels);
    this.settingsChanged();
  }

  public extensionTypeUpdate(event,id) {

    this.levels.find(v=>{
      return v.id == id;
    }).extensionType =  event.currentTarget.value;

    //console.log(event, id);
    //console.log(this.levels);
    this.settingsChanged();
  }


  private _selectedRetracementSettingName: string;
  public get selectedRetracementSettingName(): string {
    return this._selectedRetracementSettingName;
  }
  public set selectedRetracementSettingName(value: string) {
    this._selectedRetracementSettingName = value;
    this.settingsChanged();
  }



  private _selectedSetting: IRetracementSettingsRowsSet;
  public get selectedSetting(): IRetracementSettingsRowsSet {
    return this._selectedSetting;
  }
  public set selectedSetting(value: IRetracementSettingsRowsSet) {
    this._selectedSetting = value;
  }


  @Output() settingsChange: EventEmitter<settingChanges> = new EventEmitter();

  public settingsChanged()
  {
      var changes = new settingChanges();
      changes.settingName = this.selectedRetracementSettingName;
      changes.settingType = this.retracementsType;
      changes.data = this.levels;
      this.settingsChange.emit(changes);
  }

  onChange(value) {
    ////console.log(value.currentTarget.value);
  //  this.drawingService.selectedActiveUpwaveRetracementSettingName = this.selectedSetting.name;
    this.selectedRetracementSettingName = this.selectedSetting.name
    this.levels = this.drawingService.retracementsList.find(v=>{
      return v.name == this.selectedSetting.name && v.type==this.retracementsType
    }).levels;


    this.settingsChanged();
  }


  public lineStyles =[
    {
      value:LineStyle.Solid,
      label:"Solid"
    },
    {
      value:LineStyle.Dotted,
      label:"Dotted"
    },
    {
      value:LineStyle.Dashed,
      label:"Dashed"
    },
    {
      value:LineStyle.LargeDashed,
      label:"LargeDashed"
    },
    {
      value:LineStyle.SparseDotted,
      label:"SparseDotted"
    }
  ]


  public resetCurrentValues()
  {
    let defaultLevels = this.drawingService.retracementSettings.getDefaultLevels();

    this.levels = defaultLevels;
    this.settingsChanged();
  }
}

export class settingChanges
{
  settingName:string;
  settingType:RetracementTypes;
  data:IRetracementSettingsRow[];
}
